let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dT127")).then(() => parcelRequire('L8FVn'));